import React, { useState, useEffect } from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import DialogTitle from '@material-ui/core/DialogTitle';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import RadioGroup from '@material-ui/core/RadioGroup';
import Radio from '@material-ui/core/Radio';
import TextareaAutosize from '@material-ui/core/TextareaAutosize';
import Typography from '@material-ui/core/Typography';

import { useNotification } from 'context/notification';
import { useLoader } from 'context/loader';
import { requestProgramAccess } from 'services/programs';
import { PrimaryButton, SecondaryButton } from 'components/common/buttons';

import { styles } from './styles';
import { Divider, Grid } from '@material-ui/core';
import { sendEmailNotification } from 'services/programs';
import useApplicationPermission from 'components/common/hooks/useCollabPermission';

export default function RequestAccess({
  isOpen,
  closePopup,
  programInfo,
  currentUser,
  programOwnerInfo,
  updateAllPrograms,
}) {
  const classes = styles();
  const { dispatchLoader } = useLoader();
  const { dispatchNotification } = useNotification();
  const { userId, firstName, lastName, emailAddress } = currentUser;
  const [open, setOpen] = useState(isOpen);
  const [accessType, setAccessType] = React.useState('1');
  const [requestMessage, setRequestMessage] = React.useState('');
  const { collabSuperAdminRole } = useApplicationPermission();

  var currentdate = new Date();
  var datetime =
    currentdate.getFullYear() +
    '-' +
    (currentdate.getMonth() + 1) +
    '-' +
    currentdate.getDate() +
    ' ' +
    currentdate.getHours() +
    ':' +
    currentdate.getMinutes() +
    ':' +
    currentdate.getSeconds();

  const handleChange = (event) => {
    setAccessType(event.target.value);
  };

  const handleClose = () => {
    setOpen(false);
    closePopup();
  };

  const handleRequestMessage = (e) => {
    setRequestMessage(e.target.value);
  };

  const handleRequestAccessClick = (e) => {
    let isValidated = e.currentTarget.form.reportValidity();
    if (isValidated) {
      let requestAccessDetails = {
        requesterName: `${firstName} ${lastName}`,
        requesterId: userId,
        programName: programInfo.programName,
        programId: programInfo.programId,
        requestingTime: datetime,
        approverName: `${programOwnerInfo && programOwnerInfo.firstName} ${
          programOwnerInfo && programOwnerInfo.lastName
        }`,
        approverId: programInfo.ownerId,
        requestedAccessLevel: accessType,
        requesterMessage: requestMessage,
        userId: programInfo.ownerId,
        accessRank: collabSuperAdminRole !== undefined ? 0 : undefined,
      };
      requestProgramAccess(requestAccessDetails).then((res) => {
        dispatchLoader({ show: false });
        if (res.status === 'success') {
          dispatchNotification({
            show: true,
            severity: 'success',
            message: 'Program access requested successfully',
          });
          updateAllPrograms();
          handleClose();
          const programUrl = `${
            process.env.REACT_APP_MFE_DESIGNER_ORIGIN || window.location.origin
          }/collaboration/#/program/${programInfo.programId}`;

          const emailDetails = {
            recipient_email: programOwnerInfo.email,
            subject: `Requesting ${
              accessType === '1' ? 'View Only Access' : 'Full Access '
            } for IPM Cloud: "${programInfo.programName}"`,
            recipient_name: programOwnerInfo.firstName,
            program_link: programUrl,
            emailContent: `
            <b>${firstName} ${lastName}</b> (email address: ${emailAddress}) has requested access to the <b>"${programInfo.programName}"</b> program within the IPM Cloud platform.
            <br/><br/>
            To review and manage access requests, please visit the program's dashboard ${programUrl}.
            <br/><br/>
            Thank you for your attention to this matter.
            <br/><br/>
            Best regards<br/><br/>`,
          };
          sendEmailNotification(emailDetails);
        } else {
          dispatchNotification({
            show: true,
            severity: 'error',
            message: `Error: ${res.error_message}`,
          });
        }
      });
    }
  };

  useEffect(() => {
    setOpen(isOpen);
  }, [isOpen]);

  return (
    <>
      <Dialog
        open={open}
        onClose={handleClose}
        fullWidth
        className={classes.root}
      >
        <DialogTitle disableTypography>Request Access</DialogTitle>
        <Divider />
        <form noValidate>
          <DialogContent className={classes.dialogContent}>
            <Grid container direction="column">
              <RadioGroup
                name="spacing"
                aria-label="spacing"
                value={accessType}
                onChange={handleChange}
                row
              >
                <Grid item xs={5}>
                  <FormControlLabel
                    key={'full access'}
                    value={'2'}
                    className={classes.smallRadioButton}
                    control={
                      <Radio className={classes.radioPrimary} size="medium" />
                    }
                    label={
                      <Typography
                        className={classes.requestAccessSelectionHeader}
                      >
                        Full access
                      </Typography>
                    }
                  />
                  <br />
                  <Typography className={classes.accessTypeDesc}>
                    if you need to edit the program
                  </Typography>
                </Grid>
                <Grid item xs={1}></Grid>
                <Grid item xs={6}>
                  <FormControlLabel
                    className={`${classes.requestMessage} ${classes.smallRadioButton}`}
                    key={'view only'}
                    value={'1'}
                    control={<Radio size="medium" />}
                    label={
                      <Typography
                        className={classes.requestAccessSelectionHeader}
                      >
                        View only
                      </Typography>
                    }
                  />
                  {''}
                  <br />
                  <Typography className={classes.accessTypeDesc}>
                    if you need to just observe the program
                  </Typography>
                </Grid>
              </RadioGroup>
            </Grid>
            <TextareaAutosize
              placeholder="Explain your request"
              className={classes.messageText}
              value={requestMessage}
              onChange={handleRequestMessage}
            />
          </DialogContent>
          <DialogActions className={classes.dialogActions}>
            <SecondaryButton onClick={handleClose}>Cancel</SecondaryButton>
            <PrimaryButton onClick={handleRequestAccessClick}>
              Request Access
            </PrimaryButton>
          </DialogActions>
        </form>
      </Dialog>
    </>
  );
}
